import * as React from 'react';
import { HeaderSecondary } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';
import { NotFoundFeature } from './notFound';

export const NotFound:React.SFC = () => (
  <React.Fragment>
    <HeaderSecondary navBar />
    <NotFoundFeature />
    <FooterFeature isDisplay={true} />
  </React.Fragment>
);
